import { TenantConfig } from 'common/api-types/director';

import { gatewayApiAgent } from './apiAgents';

export async function fetchTenantConfig(countryCode?: string) {
  return gatewayApiAgent
    .get<TenantConfig>('/director/public/v1/me/config', {
      ...(countryCode && { params: { countryCode } }),
    })
    .then((response) => response.data);
}
